import { AppImage, Link, FormattedDate } from '@shopmuchmore/design-system';
import type { PendingReview } from '../reviews.types';

interface ReviewItemProps {
    product: PendingReview;
}

export function ReviewItem({ product }: ReviewItemProps) {
    return (
        <div className="bg-white border-[1.5px] border-gray-100 rounded-[24px] p-4 md:p-6 flex flex-col md:flex-row gap-6 items-start md:items-center transition-all hover:border-primary/20 hover:shadow-sm">
            <AppImage src={product.product_image} alt={product.product_name} size='md' />

            <div className="flex-1 min-w-0 space-y-1">
                <h4 className="font-bold text-gray-900 text-lg line-clamp-1">{product.product_name}</h4>
                <div className="text-sm text-gray-500 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                    <span className="font-medium text-gray-600">Delivered on <FormattedDate date={product.delivery_date} /></span>
                    <span className="hidden sm:inline text-gray-300">•</span>
                    <span className="text-gray-400">Order #{product.order_number}</span>
                </div>
            </div>

            <div className="w-full md:w-auto">
                <Link href={`/account/reviews/write?productSlug=${product.product_slug}&productId=${product.product_id || ''}&orderNo=${product.order_number}`} variant="outline">
                    Write a Review
                </Link>
            </div>
        </div>
    );
}

